import React, { useEffect, useState } from 'react'
import { Row, Col, Container, Dropdown, OverlayTrigger, Form, Tooltip, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Card from '../../components/Card'
import CustomToggle from '../../components/dropdowns'
import ShareOffcanvas from '../../components/share-offcanvas'
import { MuiFileInput } from 'mui-file-input'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CarouselN from 'react-bootstrap/Carousel';

//image
import user1 from '../../assets/images/user/1.jpg'
import user01 from '../../assets/images/user/01.jpg'
import user2 from '../../assets/images/user/02.jpg'
import user3 from '../../assets/images/user/03.jpg'
import user4 from '../../assets/images/user/04.jpg'
import img1 from '../../assets/images/small/07.png'
import img2 from '../../assets/images/small/08.png'
import img3 from '../../assets/images/small/09.png'
import img4 from '../../assets/images/small/10.png'
import img5 from '../../assets/images/small/11.png'
import img6 from '../../assets/images/small/12.png'
import img7 from '../../assets/images/small/13.png'
import img8 from '../../assets/images/small/14.png'
import p1 from '../../assets/images/page-img/p1.jpg'
import s1 from '../../assets/images/page-img/s1.jpg'
import s2 from '../../assets/images/page-img/s2.jpg'
import s3 from '../../assets/images/page-img/s3.jpg'
import s4 from '../../assets/images/page-img/s4.jpg'
import s5 from '../../assets/images/page-img/s5.jpg'
import p2 from '../../assets/images/page-img/p2.jpg'
import p3 from '../../assets/images/page-img/p3.jpg'
import p4 from '../../assets/images/page-img/p4.jpg'
import p5 from '../../assets/images/page-img/p5.jpg'
import img42 from '../../assets/images/page-img/42.png'
import icon1 from '../../assets/images/icon/01.png'
import icon2 from '../../assets/images/icon/02.png'
import icon3 from '../../assets/images/icon/03.png'
import icon4 from '../../assets/images/icon/04.png'
import icon5 from '../../assets/images/icon/05.png'
import icon6 from '../../assets/images/icon/06.png'
import icon7 from '../../assets/images/icon/07.png'
import img9 from '../../assets/images/small/img-1.jpg'
import img10 from '../../assets/images/small/img-2.jpg'
import loader from '../../assets/images/page-img/page-load-loader.gif'
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { getToken } from '../../utils/auth';
import { useNavigate } from 'react-router-dom'
import { MdOutlineDone } from "react-icons/md";
import moment from 'moment';
import InfiniteScroll from "react-infinite-scroll-component";
import PostCard from './Post/PostCard'
import useAuth from '../../utils/useAuth'
import Sponsored from './Sponsored'
import { useUser } from '../../Context/UserContext'

const ConnectionPosts = () => {
    const { userData } = useUser();

    useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [description, setDescription] = useState("");
    const [selectedFile, setSelectedFile] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});

    const toggleExpand = (index) => {
        setExpandedRows((prevExpandedRows) => ({
            ...prevExpandedRows,
            [index]: !prevExpandedRows[index],
        }));
    };

    const handleFileInputChange = (event) => {
        setSelectedFile([...event.target.files]);
        toast.success('File selected!')
    };
    const [categorypost, setCategorypost] = useState("public");

    const handleCategoryChange = (e) => {
        setCategorypost(e.target.value);
    };
    const [photos, setPhotos] = useState([]);
    const handlePost = async () => {

        if (!description) {
            toast.error("Description is required");
            return;
        }
        try { 
            const token = getToken();
            const formData = new FormData();
            for (let i = 0; i < selectedFile.length; i++) {
                formData.append('files', selectedFile[i]);
            }

            const uploadResponse = await axios.post(
                `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            setPhotos(uploadResponse.data.data)
            postPhoto(uploadResponse.data.data);


            //   setShow(false);
        } catch (error) {
            console.log("Failed to create post:", error);
            toast.error(error?.uploadResponse?.data?.message || "Failed to Upload Image/Video");
        }
    };


    const postPhoto = async (photoss) => {
        if (!description) {
            toast.error("Description is required");
            return;
        }
        try {
            const token = getToken();
            const postData = {
                description: description,
                photos: photoss,
                postType: categorypost,
            };

            const postResponse = await axios.post(
                `${process.env.REACT_APP_URL}/api/post`,
                postData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );
            handleAllPost(true);
            toast.success("Post created successfully");
            setDescription("");
            setSelectedFile([]);
            //   setShow(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.log("Failed Posting ", error);
        } finally {
            setShow(false);
        }
    }


    const [post, setPost] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const handleAllPost = async (updateData = false) => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/post/all?page=${page}&limit=5&searchFor=connection`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            }
            )
            // setPost(response.data.data.allPosts);
            // setHasMore(response.data.data.allPosts.length > 0);
            if (updateData) {
                setPost(response.data.data.allPosts);
            } else {
                setPost((prevPost) => [...prevPost, ...response.data.data.allPosts]);
            }
            setHasMore(response.data.data.allPosts.length > 0);

        } catch (error) {
            console.log("Failed Fetching Posts", error);
        }
    }

    useEffect(() => {
        handleAllPost();
    }, [page])

    const handleSavePost = async (postID) => {
        try {
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/post/save/${postID}`, {}, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    // "Content-Type": "multipart/form-data"
                }
            }
            )
            toast.success(response.data.message)
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed Saving Post");
            console.log("Failed Saving Posts", error);
        }
    }

    const profileImage = userData?.profileImageLink ? userData?.profileImageLink : "/profile.png";

    const [upcoming, setUpcoming] = useState([]);
    const handleUpcoming = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/event/upcoming/all`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    // "Content-Type": "multipart/form-data"
                }
            }
            )
            setUpcoming(response.data.data.allEvents);
        } catch (error) {
            console.log("Failed Fetching Upcoming Event", error);
        }
    }

    useEffect(() => {
        handleUpcoming();
    }, [])

    const [qrPopupOpen, setQrPopupOpen] = useState(false);
    const [qrImageUrl, setQrImageUrl] = useState('');

    const handleQrClick = (imageUrl) => {
        setQrImageUrl(imageUrl);
        setQrPopupOpen(true);
    };

    const closeQrPopup = () => {
        setQrPopupOpen(false);
    };


    
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const [reportDescription,setReportDescription] = useState("");
    const [reportId, setReportId] = useState("");
    const handleReportClick = (reqid) => {
      setReportId(reqid);
      setReportModalOpen(true);
    };
  
    const closeReportModal = () => {
      setReportModalOpen(false);
    };
    const handleReport = async () => {
      if (!reportDescription) {
          toast.info("Report issue is required");
          return;
        }
      try {
        const token = getToken();
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/report`,
          {
            reportFor: "post",
            issueDescription: reportDescription,
            userId: "",
            postId: reportId,
            eventId: "",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        closeReportModal();
        setReportId("");
        setReportDescription("");
        toast.success(response.data.message);
  
      } catch (error) {
          setReportId("");
        setReportDescription("");
        toast.error(error?.response?.data?.message || "Failed Reporting Post");
        console.log("Failed SaviReportingng Posts", error);
      }
    };

    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<div id="content-page" className="content-page">

                <Container>
                    <Row>
                        <Col lg={8} className="row m-0 p-0">
                            <Col sm={12} >
                                <Card id="post-modal-data" className="card-block card-stretch card-height">
                                    <div className="card-header d-flex justify-content-between">
                                        <div className="header-title">
                                            <h4 className="card-title">Create Post</h4>
                                        </div>
                                    </div>
                                    <Card.Body >
                                        <div className="d-flex align-items-center">
                                            <div className="user-img">
                                                <img src={profileImage} alt="user1" className="avatar-60 rounded-circle" />
                                            </div>
                                            <form className="post-text ms-3 w-100 " onClick={handleShow}>
                                                <input type="text" className="form-control rounded" placeholder="Write something here..." style={{ border: "none" }} />
                                            </form>
                                        </div>
                                        <hr></hr>
                                        <ul className=" post-opt-block d-flex list-inline m-0 p-0 flex-wrap">
                                            <li className="me-3 mb-md-0 mb-2">
                                                <Link to="#" className="btn btn-soft-primary" onClick={handleShow}>
                                                    <img src={img1} alt="icon" className="img-fluid me-2" /> Photo/Video
                                                </Link>
                                            </li>
                                            <li className="me-3 mb-md-0 mb-2">
                                                <Link to="#" className="btn btn-soft-primary" onClick={handleShow}>
                                                    <img src={img2} alt="icon" className="img-fluid me-2" /> Tag Friend
                                                </Link>
                                            </li>
                                            <li className="me-3">
                                                <Link to="#" className="btn btn-soft-primary" onClick={handleShow}>
                                                    <img src={img3} alt="icon" className="img-fluid me-2" /> Category
                                                </Link>
                                            </li>
                                            <li>
                                                <button className=" btn btn-soft-primary">
                                                    <div className="card-header-toolbar d-flex align-items-center">
                                                        <Dropdown>
                                                            <Dropdown.Toggle as='div' className="lh-1">
                                                                <span className="material-symbols-outlined">
                                                                    more_horiz
                                                                </span>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item  ><Link to="/event" style={{ color: "black", textDecoration: "none" }}>Event</Link></Dropdown.Item>
                                                                {/* <Dropdown.Item  onClick={handleShow}  href="#">Check in</Dropdown.Item> */}
                                                                <Dropdown.Item onClick={handleShow} href="#">Live Video</Dropdown.Item>
                                                                {/* <Dropdown.Item  onClick={handleShow}  href="#">Gif</Dropdown.Item> 
                                                            <Dropdown.Item  onClick={handleShow}  href="#">Watch Party</Dropdown.Item> 
                                                            <Dropdown.Item  onClick={handleShow}  href="#">Play with Friend</Dropdown.Item>  */}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </button>
                                            </li>
                                        </ul>
                                    </Card.Body>
                                    <Modal size="lg" className="fade" id="post-modal" onHide={handleClose} show={show} style={{ marginTop: "100px", maxHeight: "80vh" }}>
                                        <Modal.Header className="d-flex justify-content-between">
                                            <Modal.Title id="post-modalLabel">Create Post</Modal.Title>
                                            <Link to="#" className="lh-1" onClick={handleClose} >
                                                <span className="material-symbols-outlined">close</span>
                                            </Link>
                                        </Modal.Header>
                                        <Modal.Body >
                                            <div className="d-flex align-items-center">
                                                {/* <div className="user-img">
                                                    <img src={profileImage} alt="user1" className="avatar-60 rounded-circle img-fluid" />
                                                </div> */}
                                                <form className="post-text ms-3 w-100 " data-bs-toggle="modal" data-bs-target="#post-modal">
                                                    {/* <input type="text" className="form-control rounded" placeholder="What's on your mind?" style={{border:"none"}} onChange={(e)=> setDescription(e.target.value)}/> */}
                                                    {/* <EmojiPicker /> */}
                                                    {/* <br /> */}

                                                </form>
                                            </div>
                                            {/* <hr /> */}
                                            <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                                                <li className="col-md-12 mb-2" >
                                                    <Form.Label>
                                                        Description{" "}
                                                        <span style={{ color: "red" }}>*</span>{" "}
                                                    </Form.Label>
                                                    {/* <CKEditor
                                                        editor={ClassicEditor}
                                                        data="<p>What's on your mind?</p>"
                                                        onChange={(event, editor) => {
                                                            const data = editor.getData();
                                                            setDescription(data);
                                                        }}
                                                    /> */}
                                                    <Form.Control
                            as="textarea"
                            rows={3}
                            name="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="mb-0 py-2"
                            id=""
                            placeholder="Enter description"
                            required
                          />
                                                </li>
                                               
                                                <li className="col-md-12 mb-2" >
                                                    {/* <div className="bg-soft-primary rounded p-2 pointer me-3" onClick={handlePhotoVideoClick}>
                                                <Link to="#">Photo/Video</Link>
                                            </div> */}
                                                    {/* <input  className="bg-soft-primary rounded p-2 pointer me-3"
                                                type="file"
                                                multiple
                                                style={{width:"90%"}}
                                                onChange={handleFileInputChange}
                                                /> */}
                                                    {/* <label htmlFor="file-input" className="bg-soft-primary rounded p-2 pointer" style={{ width: "90%", textAlign:"center" }}>
                                                    Select File
                                                    <input
                                                        id="file-input"
                                                        type="file"
                                                        multiple
                                                        style={{ display: "none" }}
                                                        onChange={handleFileInputChange}
                                                    />
                                                </label> */}
                                                    <Form.Label>
                                                        Image{" "}
                                                        <span style={{ color: "red" }}>*</span>{" "}
                                                    </Form.Label>
                                                    <label
                                                        htmlFor="file-input"
                                                        style={{ cursor: "pointer", width: "100%" }}
                                                    >
                                                        <div
                                                            className="bg-soft-primary rounded p-1 pointer"
                                                            style={{
                                                                width: "100%",
                                                                textAlign: "center",
                                                                fontSize: "1.2rem",
                                                                position: "relative",
                                                                borderRadius: "10px",
                                                            }}
                                                        >
                                                            <input
                                                                id="file-input"
                                                                type="file"
                                                                name="image"
                                                                multiple
                                                                style={{ display: "none" }}
                                                                onChange={handleFileInputChange}
                                                            />
                                                            <span>
                                                                {
                                                                    selectedFile.length > 0 ?
                                                                        <MdOutlineDone style={{ fontSize: '25px' }} />
                                                                        :
                                                                        <i className="fas fa-upload"></i>
                                                                }
                                                            </span>
                                                            <p style={{ marginTop: ".5rem" }}>
                                                                Click to Select Files
                                                            </p>
                                                        </div>
                                                    </label>


                                                </li>
                                                <li className="col-md-12 mt-1">
                          <Form.Group className="form-group">
                            <Form.Label>
                              Select a Category{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <div className="mb-0 ">
                              <Form.Check
                                style={{ marginRight: "20px" }}
                                type="radio"
                                name="category"
                                value="public"
                                label="Public"
                                checked={categorypost === "public"}
                                onChange={handleCategoryChange}
                                required
                              />
                              <Form.Check
                                type="radio"
                                name="category"
                                value="private"
                                label="Private"
                                checked={categorypost === "private"}
                                onChange={handleCategoryChange}
                                required
                              />
                            </div>
                          </Form.Group>
                        </li>

                                            </ul>
                                            {/* <hr /> */}

                                            <button type="submit" className="btn btn-primary d-block w-100 mt-0" onClick={handlePost}>Post</button>
                                        </Modal.Body>
                                    </Modal>
                                </Card>
                            </Col>
                           <PostCard  post={post} page={page} setPage={setPage} hasMore={hasMore} handleAllPost={handleAllPost}/>

                            {/* <Col sm={12}>
                                <div className="card card-block card-stretch card-height">
                                    <div className="card-body">
                                        <div className="user-post-data">
                                            <div className="d-flex justify-content-between">
                                                <div className="me-3">
                                                    <img className="rounded-circle img-fluid" src={user3} alt="" />
                                                </div>
                                                <div className="w-100">
                                                    <div className="d-flex  justify-content-between">
                                                        <div>
                                                            <h5 className="mb-0 d-inline-block">Barb Ackue</h5>
                                                            <span className="mb-0 ps-1 d-inline-block">Added New Image in a Post</span>
                                                            <p className="mb-0 text-primary">1 hour ago</p>
                                                        </div>
                                                        <div className="card-post-toolbar" style={{ display: "flex" }}>
                                                            <div>
                                                                <img src="/QR.png" style={{
                                                                    width: "50px",
                                                                    height: "50px"
                                                                }} />
                                                            </div>                                                        <Dropdown>
                                                                <Dropdown.Toggle variant="bg-transparent">
                                                                    <span className="material-symbols-outlined">
                                                                        more_horiz
                                                                    </span>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className="dropdown-menu m-0 p-0">
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <div className="h4">
                                                                                <i className="ri-save-line"></i>
                                                                            </div>
                                                                            <div className="data ms-2">
                                                                                <h6>Save Post</h6>
                                                                                <p className="mb-0">Add this to your saved items</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className="p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-close-circle-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Hide Post</h6>
                                                                                <p className="mb-0">See fewer posts like this.</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-user-unfollow-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Unfollow User</h6>
                                                                                <p className="mb-0">Stop seeing posts but stay friends.</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-notification-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Notifications</h6>
                                                                                <p className="mb-0">Turn on notifications for this post</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nulla dolor, ornare at commodo non, feugiat non nisi. Phasellus faucibus mollis pharetra. Proin blandit ac massa sed rhoncus</p>
                                        </div>
                                        <div className="user-post">
                                            <Link to="#">
                                                <img src={p4} alt="post1" className="img-fluid rounded w-100" />
                                            </Link>
                                        </div>
                                        <div className="comment-area mt-3">
                                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                <div className="like-block position-relative d-flex align-items-center">
                                                    <div className="d-flex align-items-center">
                                                        <div className="like-data">
                                                            <Dropdown>
                                                                <Dropdown.Toggle as={CustomToggle} >
                                                                    <img src={icon1} className="img-fluid" alt="" />
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className=" py-2">
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Like</Tooltip>} className="ms-2 me-2" ><img src={icon1} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Love</Tooltip>} className="me-2" ><img src={icon2} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Happy</Tooltip>} className="me-2" ><img src={icon3} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>HaHa</Tooltip>} className="me-2" ><img src={icon4} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Think</Tooltip>} className="me-2" ><img src={icon5} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Sade</Tooltip>} className="me-2" ><img src={icon6} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Lovely</Tooltip>} className="me-2" ><img src={icon7} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                        <div className="total-like-block ms-2 me-3">
                                                            <Dropdown>
                                                                <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                                    140 Likes
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Other</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                    <div className="total-comment-block">
                                                        <Dropdown>
                                                            <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                                20 Comment
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                                                <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                                                <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                                                <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                                                <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                                                <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                                                <Dropdown.Item href="#">Other</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                                <ShareOffcanvas />
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className="card card-block card-stretch card-height">
                                    <div className="card-body">
                                        <div className="user-post-data">
                                            <div className="d-flex justify-content-between">
                                                <div className="me-3">
                                                    <img className="rounded-circle img-fluid" src={user4} alt="" />
                                                </div>
                                                <div className="w-100">
                                                    <div className=" d-flex  justify-content-between">
                                                        <div>
                                                            <h5 className="mb-0 d-inline-block">Ira Membrit</h5>
                                                            <p className="mb-0 ps-1 d-inline-block">Update her Status</p>
                                                            <p className="mb-0 text-primary">6 hour ago</p>
                                                        </div>
                                                        <div className="card-post-toolbar" style={{ display: "flex" }}>
                                                            <div>
                                                                <img src="/QR.png" style={{
                                                                    width: "50px",
                                                                    height: "50px"
                                                                }} />
                                                            </div>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="bg-transparent">
                                                                    <span className="material-symbols-outlined">
                                                                        more_horiz
                                                                    </span>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className="dropdown-menu m-0 p-0">
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <div className="h4">
                                                                                <i className="ri-save-line"></i>
                                                                            </div>
                                                                            <div className="data ms-2">
                                                                                <h6>Save Post</h6>
                                                                                <p className="mb-0">Add this to your saved items</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className="p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-close-circle-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Hide Post</h6>
                                                                                <p className="mb-0">See fewer posts like this.</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-user-unfollow-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Unfollow User</h6>
                                                                                <p className="mb-0">Stop seeing posts but stay friends.</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-notification-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Notifications</h6>
                                                                                <p className="mb-0">Turn on notifications for this post</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nulla dolor, ornare at commodo non, feugiat non nisi. Phasellus faucibus mollis pharetra. Proin blandit ac massa sed rhoncus</p>
                                        </div>
                                        <div className="comment-area mt-3">
                                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                <div className="like-block position-relative d-flex align-items-center">
                                                    <div className="d-flex align-items-center">
                                                        <div className="like-data">
                                                            <Dropdown>
                                                                <Dropdown.Toggle as={CustomToggle} >
                                                                    <img src={icon1} className="img-fluid" alt="" />
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className=" py-2">
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Like</Tooltip>} className="ms-2 me-2" ><img src={icon1} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Love</Tooltip>} className="me-2" ><img src={icon2} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Happy</Tooltip>} className="me-2" ><img src={icon3} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>HaHa</Tooltip>} className="me-2" ><img src={icon4} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Think</Tooltip>} className="me-2" ><img src={icon5} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Sade</Tooltip>} className="me-2" ><img src={icon6} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Lovely</Tooltip>} className="me-2" ><img src={icon7} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                        <div className="total-like-block ms-2 me-3">
                                                            <Dropdown>
                                                                <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                                    140 Likes
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Other</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                    <div className="total-comment-block">
                                                        <Dropdown>
                                                            <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                                20 Comment
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                                                <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                                                <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                                                <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                                                <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                                                <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                                                <Dropdown.Item href="#">Other</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                                <ShareOffcanvas />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className="card card-block card-stretch card-height">
                                    <div className="card-body">
                                        <div className="post-item">
                                            <div className="d-flex justify-content-between">
                                                <div className="me-3">
                                                    <img className="rounded-circle img-fluid avatar-60" src={user1} alt="" />
                                                </div>
                                                <div className="w-100">
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            <h5 className="mb-0 d-inline-block">Bni Cyst</h5>
                                                            <p className="ms-1 mb-0 ps-1 d-inline-block">Changed Profile Picture</p>
                                                            <p className="mb-0">3 day ago</p>
                                                        </div>
                                                        <div className="card-post-toolbar" style={{ display: "flex" }}>
                                                            <div>
                                                                <img src="/QR.png" style={{
                                                                    width: "50px",
                                                                    height: "50px"
                                                                }} />
                                                            </div>                                                    <Dropdown>
                                                                <Dropdown.Toggle variant="bg-transparent">
                                                                    <span className="material-symbols-outlined">
                                                                        more_horiz
                                                                    </span>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className="dropdown-menu m-0 p-0">
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <div className="h4">
                                                                                <i className="ri-save-line"></i>
                                                                            </div>
                                                                            <div className="data ms-2">
                                                                                <h6>Save Post</h6>
                                                                                <p className="mb-0">Add this to your saved items</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className="p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-close-circle-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Hide Post</h6>
                                                                                <p className="mb-0">See fewer posts like this.</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-user-unfollow-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Unfollow User</h6>
                                                                                <p className="mb-0">Stop seeing posts but stay friends.</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-notification-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Notifications</h6>
                                                                                <p className="mb-0">Turn on notifications for this post</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="user-post text-center">
                                            <Link to="#"><img src={p5} alt="post1" className="img-fluid rounded w-100 mt-3" /></Link>
                                        </div>
                                        <div className="comment-area mt-3">
                                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                <div className="like-block position-relative d-flex align-items-center">
                                                    <div className="d-flex align-items-center">
                                                        <div className="like-data">
                                                            <Dropdown>
                                                                <Dropdown.Toggle as={CustomToggle} >
                                                                    <img src={icon1} className="img-fluid" alt="" />
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className=" py-2">
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Like</Tooltip>} className="ms-2 me-2" ><img src={icon1} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Love</Tooltip>} className="me-2" ><img src={icon2} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Happy</Tooltip>} className="me-2" ><img src={icon3} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>HaHa</Tooltip>} className="me-2" ><img src={icon4} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Think</Tooltip>} className="me-2" ><img src={icon5} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Sade</Tooltip>} className="me-2" ><img src={icon6} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Lovely</Tooltip>} className="me-2" ><img src={icon7} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                        <div className="total-like-block ms-2 me-3">
                                                            <Dropdown>
                                                                <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                                    140 Likes
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Other</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                    <div className="total-comment-block">
                                                        <Dropdown>
                                                            <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                                20 Comment
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                                                <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                                                <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                                                <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                                                <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                                                <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                                                <Dropdown.Item href="#">Other</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                                <ShareOffcanvas />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className="card card-block card-stretch card-height">
                                    <div className="card-body">
                                        <div className="user-post-data">
                                            <div className="d-flex justify-content-between">
                                                <div className="me-3">
                                                    <img className="rounded-circle img-fluid" src={user2} alt="" />
                                                </div>
                                                <div className="w-100">
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            <h5 className="mb-0 d-inline-block">Paige Turner</h5>
                                                            <p className="mb-0 ps-1 d-inline-block">Added New Video in his Timeline</p>
                                                            <p className="mb-0 text-primary">1 day ago</p>
                                                        </div>
                                                        <div className="card-post-toolbar" style={{ display: "flex" }}>
                                                            <div>
                                                                <img src="/QR.png" style={{
                                                                    width: "50px",
                                                                    height: "50px"
                                                                }} />
                                                            </div>                                                        <Dropdown>
                                                                <Dropdown.Toggle variant="bg-transparent">
                                                                    <span className="material-symbols-outlined">
                                                                        more_horiz
                                                                    </span>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className="dropdown-menu m-0 p-0">
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <div className="h4">
                                                                                <i className="ri-save-line"></i>
                                                                            </div>
                                                                            <div className="data ms-2">
                                                                                <h6>Save Post</h6>
                                                                                <p className="mb-0">Add this to your saved items</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className="p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-close-circle-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Hide Post</h6>
                                                                                <p className="mb-0">See fewer posts like this.</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-user-unfollow-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Unfollow User</h6>
                                                                                <p className="mb-0">Stop seeing posts but stay friends.</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className=" p-3" to="#">
                                                                        <div className="d-flex align-items-top">
                                                                            <i className="ri-notification-line h4"></i>
                                                                            <div className="data ms-2">
                                                                                <h6>Notifications</h6>
                                                                                <p className="mb-0">Turn on notifications for this post</p>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nulla dolor, ornare at commodo non, feugiat non nisi. Phasellus faucibus mollis pharetra. Proin blandit ac massa sed rhoncus</p>
                                        </div>
                                        <div className="user-post">
                                            <div className="ratio ratio-16x9">
                                                <iframe title="vedio" src="https://www.youtube.com/embed/j_GsIanLxZk?rel=0" ></iframe>
                                            </div>
                                        </div>
                                        <div className="comment-area mt-3">
                                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                <div className="like-block position-relative d-flex align-items-center">
                                                    <div className="d-flex align-items-center">
                                                        <div className="like-data">
                                                            <Dropdown>
                                                                <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                                    <img src={icon1} className="img-fluid" alt="" />
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className=" py-2">
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Like</Tooltip>} className="ms-2 me-2" ><img src={icon1} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Love</Tooltip>} className="me-2" ><img src={icon2} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Happy</Tooltip>} className="me-2" ><img src={icon3} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>HaHa</Tooltip>} className="me-2" ><img src={icon4} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Think</Tooltip>} className="me-2" ><img src={icon5} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Sade</Tooltip>} className="me-2" ><img src={icon6} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Lovely</Tooltip>} className="me-2" ><img src={icon7} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                        <div className="total-like-block ms-2 me-3">
                                                            <Dropdown>
                                                                <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                                    140 Likes
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                                                    <Dropdown.Item href="#">Other</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                    <div className="total-comment-block">
                                                        <Dropdown>
                                                            <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                                20 Comment
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                                                <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                                                <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                                                <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                                                <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                                                <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                                                <Dropdown.Item href="#">Other</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                                <ShareOffcanvas />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Col> */}
                        </Col>
                        <Col lg={4}>
                            <Sponsored/>
                            <Card>
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Upcoming Events</h4>
                                    </div>
                                    {/* <div className="card-header-toolbar d-flex align-items-center">
                                        <Dropdown>
                                            <Dropdown.Toggle as={CustomToggle} id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                                                <i className="ri-more-fill h4"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className=" dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                <Dropdown.Item href="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                               <Dropdown.Item href="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                <Dropdown.Item href="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div> */}
                                </div>
                                <Card.Body>
                                    <ul className="media-story list-inline m-0 p-0">
                                        {upcoming?.length === 0 ? (
                                            <li className="d-flex mb-4 align-items-center">
                                                <div className="stories-data ms-3">
                                                    <h5 className="mb-1" style={{ fontWeight: 'bold', color: 'gray' }}>No upcoming events</h5>
                                                </div>
                                            </li>
                                        ) : (
                                            upcoming.map((data, index) => (
                                                <li key={index} className="d-flex mb-4 align-items-center">
                                                    <img src={s5} alt="story1" className="rounded-circle img-fluid" style={{ width: '50px', height: '50px' }} />
                                                    <div className="stories-data ms-3">
                                                        <h5 className="mb-1" style={{ fontWeight: 'bold', textTransform: 'capitalize' }}>{data?.title}</h5>
                                                        <p className="mb-0">
                                                            {moment(data?.startDate).format('MMMM Do YYYY, h:mm a')}
                                                        </p>
                                                        <p className="mb-0">
                                                            Organized by: {data?.userId?.firstName} {data?.userId?.lastName}
                                                        </p>
                                                    </div>
                                                </li>
                                            ))
                                        )}
                                    </ul>
                                </Card.Body>
                            </Card>
                            {/* <Card>
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Stories</h4>
                                    </div>
                                </div>
                                <Card.Body>
                                    <ul className="media-story list-inline m-0 p-0">
                                        <li className="d-flex mb-3 align-items-center">
                                            <i className="ri-add-line"></i>
                                            <div className="stories-data ms-3">
                                                <h5>Creat Your Story</h5>
                                                <p className="mb-0">time to story</p>
                                            </div>
                                        </li>
                                        <li className="d-flex mb-3 align-items-center active">
                                            <img src={s2} alt="story-img" className="rounded-circle img-fluid" />
                                            <div className="stories-data ms-3">
                                                <h5>Anna Mull</h5>
                                                <p className="mb-0">1 hour ago</p>
                                            </div>
                                        </li>
                                        <li className="d-flex mb-3 align-items-center">
                                            <img src={s3} alt="story-img" className="rounded-circle img-fluid" />
                                            <div className="stories-data ms-3">
                                                <h5>Ira Membrit</h5>
                                                <p className="mb-0">4 hour ago</p>
                                            </div>
                                        </li>
                                        <li className="d-flex align-items-center">
                                            <img src={s1} alt="story-img" className="rounded-circle img-fluid" />
                                            <div className="stories-data ms-3">
                                                <h5>Bob Frapples</h5>
                                                <p className="mb-0">9 hour ago</p>
                                            </div>
                                        </li>
                                    </ul>
                                    <Link to="#" className="btn btn-primary d-block mt-3">See All</Link>
                                </Card.Body>
                            </Card> */}

                            {/* <Card>
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Upcoming Birthday</h4>
                                    </div>
                                </div>
                                <Card.Body>
                                    <ul className="media-story list-inline m-0 p-0">
                                        <li className="d-flex mb-4 align-items-center">
                                            <img src={user01} alt="story3" className="rounded-circle img-fluid" />
                                            <div className="stories-data ms-3">
                                                <h5>Anna Sthesia</h5>
                                                <p className="mb-0">Today</p>
                                            </div>
                                        </li>
                                        <li className="d-flex align-items-center">
                                            <img src={user2} alt="story-img" className="rounded-circle img-fluid" />
                                            <div className="stories-data ms-3">
                                                <h5>Paul Molive</h5>
                                                <p className="mb-0">Tomorrow</p>
                                            </div>
                                        </li>
                                    </ul>
                                </Card.Body>
                            </Card> */}

                        </Col>
                        {/* <div className="col-sm-12 text-center">
                            <img src={loader} alt="loader" style={{ height: "100px" }} />
                        </div> */}
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default ConnectionPosts
